<template>
  <div class="d-flex align-items-center">
    <div class="wholesale-toggle">
      <span class="text-toggle" :class="!active && 'active'">General</span>
      <FormToggleSwitch class="FormToggleSwitch" v-model="active"/>
      <span class="text-toggle" :class="active && 'active'">Wholesale</span>
    </div>

    <FormCheckbox
      :value="allowsInvoice"

      class="form-checkbox"
      :updateOnClick="false"
      @click.native="allowsInvoice = !allowsInvoice"
    >
      Factuur betalen
    </FormCheckbox>
  </div>
</template>

<script>

import FormToggleSwitch from "@/components/Inputs/FormToggleSwitch"
import FormCheckbox from "src/components/Inputs/FormCheckbox"

export default {
  props: ['customer_group', 'magento_id', 'callback'],
  components: {
    FormToggleSwitch,
    FormCheckbox,
  },
  data() {
    const group = (this.customer_group || "").toLowerCase()
    const allowsInvoice = group === "wholesale_factuur"

    return {
      allowsInvoice,
      active: group === "wholesale" || allowsInvoice,
      disablePut: false,

      timeout: null,
    }
  },
  methods: {
    updateWholesaleGroup() {
      if (this.timeout) {
        clearTimeout(this.timeout)
        this.timeout = null
      }

      this.timeout = setTimeout(async () => {
        let wholesale = this.active ? 'Wholesale' : 'General'
        if (this.allowsInvoice) wholesale = "Wholesale_Factuur"

        await this.axios.put(`/api/wholesale/customers/${this.magento_id}/update-customer-group/${wholesale}`)
        this.callback && this.callback()
      }, 70)
    },
  },
  watch: {
    active(val) {
      if (!val) {
        this.allowsInvoice = false
      }

      if (this.disablePut) return this.disablePut = false
      this.updateWholesaleGroup()
    },
    allowsInvoice(val) {
      if (val && this.active === false) {
        this.active = true
      }

      if (this.disablePut) return this.disablePut = false
      this.updateWholesaleGroup()
    },
    customer_group() {
      this.active = (this.customer_group || "").toLowerCase() === "wholesale"
      this.disablePut = true
    },
  },
}

</script>

<style scoped>

.text-toggle {
  display: inline-block;
  font-weight: 400;
  color: rgb(120, 120, 120) !important;
  transform: translateY(2px);
}

.text-toggle.active {
  color: rgb(20, 20, 20) !important;
  font-weight: 600;
}

.FormToggleSwitch {
  margin: 0 6px;
}

.wholesale-toggle {
  display: flex;
  align-items: center;
}

</style>
